import React from 'react'
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function RealEstate() {
    return (
        <Container maxWidth="md" sx={{ py: 3 }}>
            <h2>A Complete Solution for Real Estate — Built for Buyers, Sellers &amp; Property Owners</h2>

            <Typography style={{ marginTop: 16, fontWeight: 'bold' }}>Key Highlights:</Typography>
            <Typography style={{ marginTop: 8 }}>Owned and developed entirely by our company</Typography>
            <Typography>Full customization available for business clients</Typography>

            <Typography style={{ marginTop: 24, fontWeight: 'bold' }}>Features:</Typography>
            <Typography style={{ marginTop: 8 }}>✓ Zero Brokerage for Buyers &amp; Sellers</Typography>
            <Typography>✓ Property Listings with Filters &amp; Search</Typography>
            <Typography>✓ Home Services</Typography>
            <Typography>✓ Responsive Web &amp; Mobile App</Typography>

            <Typography style={{ marginTop: 24, fontWeight: 'bold' }}>Download &amp; Visit:</Typography>
            <Typography style={{ marginTop: 8 }}>
                Android:{' '}
                <a target="_blank" rel="noopener noreferrer"
                    href="https://play.google.com/store/apps/details?id=com.broker.azadi">
                    Broker Azadi on Google Play
                </a>
            </Typography>
            <Typography style={{ marginTop: 4 }}>
                iOS:{' '}
                <a target="_blank" rel="noopener noreferrer"
                    href="https://apps.apple.com/in/app/brokerazadi-buy-sell-rent-home/id6759136286">
                    Broker Azadi on App Store
                </a>
            </Typography>
            <Typography style={{ marginTop: 4 }}>
                Website:{' '}
                <a target="_blank" rel="noopener noreferrer"
                    href="https://www.brokerazadi.com">
                    www.brokerazadi.com
                </a>
            </Typography>
        </Container>
    )
}

export default RealEstate
